import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            padding: '20px',
            textAlign: 'center',
            backgroundColor: '#181a21',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          }}
        >
          <h1
            style={{ fontSize: '24px', marginBottom: '16px', color: '#e8e8ed' }}
          >
            Oops! Something went wrong
          </h1>
          <p
            style={{ fontSize: '16px', marginBottom: '24px', color: '#aeaeae' }}
          >
            We're sorry for the inconvenience. Please try reloading the page.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: 'rgb(64, 203, 135)',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '600',
              maxWidth: '200px',
              margin: '0 auto',
            }}
          >
            Reload Page
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details
              style={{
                marginTop: '24px',
                textAlign: 'left',
                maxWidth: '600px',
              }}
            >
              <summary
                style={{
                  cursor: 'pointer',
                  color: '#aeaeae',
                  fontSize: '14px',
                }}
              >
                Error Details (Development Only)
              </summary>
              <pre
                style={{
                  marginTop: '12px',
                  padding: '12px',
                  backgroundColor: '#2c2c2c',
                  color: '#e8e8ed',
                  borderRadius: '4px',
                  fontSize: '12px',
                  overflow: 'auto',
                }}
              >
                {this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
